export default __webpack_public_path__ + "static/ellagosilente-58b11ddc5de5401a4ed35df6d8d3655e.webp";